export default function () {
    let loadedNews = document.querySelectorAll('.next-article');
    return loadedNews[loadedNews.length - 1];
}